/**
 * CurricularUnitDetails selector
 *
 * @author Diogo Guedes <dguedes@ubiwhere.com>
 *
 */
import { RootState } from 'store/rootSlices';

export const getCurricularUnitDetailsSlice = (state: RootState) => state.CurricularUnitDetails;
export const getRegistration = (state: RootState) => state.StudentRegistrationDropdown.registration;
export const getUser = (state: RootState) => state.App.user;
export const getUserRegistrations = (state: RootState) => state.App.user.registrations;
export const getUserNmec = (state: RootState) => state.App.user.nmec;
export const getAppSlice = (state: RootState) => state.App.currentLocale;
